import { ALERT_KEY, SET_ALERT } from '../../types/alerts.types'

export default {
  [SET_ALERT]: (state, payload) => {
    state[ALERT_KEY] = payload
  },
}
